import { createSlice } from '@reduxjs/toolkit'

export const PaginationSlice = createSlice({
  name: 'paginate',
  initialState: {
    value: false,
  },
  reducers: {
    aaaChecked: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { updatePage } = PaginationSlice.actions

export default PaginationSlice.reducer